import { CircularProgress, Grid, IconButton, Tooltip, Zoom } from "@material-ui/core";
import { Pageview, ThumbUp } from "@material-ui/icons";
import keyBy from "lodash/keyBy";
import moment from "moment";
import React, { useState } from "react";
import { Button, Datagrid, ListContextProvider, ReferenceField, SimpleForm, TextField, useNotify } from "react-admin";
import { UploadFile } from "../../../src/Components/UploadFile";
import { EnumField } from "../../../src/Components/EnumField";
import { useAppDataProvider } from "../../../src/dataprovider";
import { CustomDateField } from "../../Components/CustomDateField";
import CreatedByField from "../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { Separator } from "../../Components/Separator";
import QuarantineDetailFilePopup from "./QuarantineDetailFilePopup";
import { QuarantineStatusType } from "../../../src/Enums/QuarantineStatusType";

const QuarantineDetail = props => {
  const [loading, setLoading] = useState(false);
  const dataProvider = useAppDataProvider();
  const [isShopReportFields, setIsShopReportFields] = React.useState(false);
  const notify = useNotify();
  const record = useState(props.data);

  const UploadFileAction = props => {
    return (
      <UploadFile
        label=""
        multiple={false}
        placeholder={"Upload"}
        onHandleFileExecute={() => {}}
        source="quarantinedetailfilerelations"
        object={{
          quarantineDetailId: record[0][0].id,
        }}
      />
    );
  };

  const fieldsInClick = () => {
    setIsShopReportFields(true);
  };

  const handleQuarantineDetailFilePopupClose = () => {
    setIsShopReportFields(false);
  };

  const FileGridPopup = () => {
    return (
      <IconButton style={{ width: 40 }} onClick={fieldsInClick}>
        <Tooltip TransitionComponent={Zoom} title="Details">
          <Pageview />
        </Tooltip>
      </IconButton>
    );
  };

  const ApproveButtonClick = () => {
    record[0][0].quarantineReasonStatus = QuarantineStatusType.Accomplished;
    record[0][0].accomplishDate = moment.utc(Date.now());
    dataProvider
      .putQuarantineDetail(record[0][0])
      .then(result => {
        notify(`Record Updated`, "success", false, true);
      })
      .catch(error => notify(`${error}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <ListContextProvider
        value={{
          data: keyBy(props.data, "id"),
          ids: props.data.map(({ id }) => id),
          currentSort: { field: "id", order: "ASC" },
        }}
      >
        <Separator />
        <Datagrid>
          <FileGridPopup />
          <SimpleForm toolbar={false} noValidate={true}>
            <UploadFileAction label="Actions" />
          </SimpleForm>
          <ReferenceField
            label="Quarantine Reason"
            record={props.record}
            source="quarantineReasonId"
            reference="quarantinereasons/reasons"
          >
            <TextField source="quarantineReasonName" />
          </ReferenceField>
          <ReferenceField
            label="Assigned Group"
            record={props.record}
            source="quarantineReasonId"
            reference="quarantinereasons/reasons"
          >
            <TextField source="assignedGroup" />
          </ReferenceField>
          <EnumField label={"Status"} enumName={"QuarantineStatusType"} source={"quarantineReasonStatus"} />
          <CreatedByField label="CREATED BY" link={false} />
          <CustomDateField source="createdDate" label="CREATED  DATE" showTime />
          <CustomDateField source="accomplishDate" label="ACCOMPLISH  DATE" showTime />
        </Datagrid>

        <Grid style={{ display: "flex", justifyContent: "end" }}>
          <Button
            label={loading ? "Resolve!" : "Resolve Quarantine"}
            disabled={props.data[0]?.quarantineReasonStatus == 0 ? false : true}
            size="medium"
            variant="contained"
            color="primary"
            onClick={ApproveButtonClick}
            style={{ margin: "8px" }}
          >
            {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbUp />}
          </Button>
        </Grid>
      </ListContextProvider>
      <Grid>
        {isShopReportFields && (
          <QuarantineDetailFilePopup
            open={isShopReportFields}
            quarantineDetail={record}
            handleClose={handleQuarantineDetailFilePopupClose}
          />
        )}
      </Grid>
    </>
  );
};

export default QuarantineDetail;
